import { render, staticRenderFns } from "./ErrorCantFetch.vue?vue&type=template&id=4202c5b7&scoped=true&"
import script from "./ErrorCantFetch.vue?vue&type=script&lang=js&"
export * from "./ErrorCantFetch.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCantFetch.vue?vue&type=style&index=0&id=4202c5b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4202c5b7",
  null
  
)

export default component.exports